export default __webpack_public_path__ + "static/media/searchIconGrey.7acb5585.svg";